import React from 'react'
import imgs from '../../images/gallery/1.webp';
import ReactImageMagnify from 'react-image-magnify';
export default function ImageMagnifiyer({currentProduct}) {
    return (
        <div className="col-md-5">
            <div className="card h-100" >
                <div className="card-body h-100">
                    <ReactImageMagnify
                        className="magnify h-100"
                        {...{
                            smallImage: {
                                alt: 'Wristwatch by Ted Baker London',
                                isFluidWidth: true,
                                src: currentProduct.url ? currentProduct.url : imgs,
                                width: 700,
                                height: 700,

                            },
                            largeImage: {
                                src: currentProduct.url ? currentProduct.url : imgs,
                                width: 800,
                                height: 800,

                            }
                        }} />
                </div>
            </div>
        </div>
    )
}
